import { i as getSafeLicenseSummary, m as getEETelemetryFallbackDistinctId, p as captureEEEvent } from "./capabilities-ZXD8uYsD.js";
//#region src/ee/interfaces/permissions.generated.ts
/**
* AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
*
* This file is generated by packages/server/scripts/generate-permissions.ts
* Run `pnpm generate:permissions` from packages/server to regenerate.
*
* Source of truth: SERVER_ROUTES in @mastra/server
*/
/**
* All known API resources.
* Derived from SERVER_ROUTES paths in @mastra/server.
*/
const RESOURCES = [
	"a2a",
	"agent-builder",
	"agent-controller",
	"agents",
	"auth",
	"background-tasks",
	"channels",
	"datasets",
	"embedders",
	"experiments",
	"infrastructure",
	"logs",
	"mcp",
	"memory",
	"observability",
	"processor-providers",
	"processors",
	"schedules",
	"scores",
	"stored-agents",
	"stored-mcp-clients",
	"stored-prompt-blocks",
	"stored-scorers",
	"stored-skills",
	"stored-workflows",
	"stored-workspaces",
	"system",
	"tool-providers",
	"tools",
	"vector",
	"vectors",
	"workflows",
	"workspaces"
];
/**
* All permission actions.
* Derived from HTTP methods and route overrides:
* - GET → read
* - POST → write or execute (context-dependent)
* - PUT/PATCH → write
* - DELETE → delete
* - Additional actions from explicit requiresPermission overrides
*/
const ACTIONS = [
	"create",
	"delete",
	"execute",
	"publish",
	"read",
	"share",
	"write"
];
/**
* All valid permission patterns.
* Use `keyof typeof PERMISSION_PATTERNS` or the `PermissionPattern` type.
*/
const PERMISSION_PATTERNS = {
	/** Full access to all resources and actions */
	"*": "*",
	/** Create all resources */
	"*:create": "*:create",
	/** Delete all resources */
	"*:delete": "*:delete",
	/** Execute all resources */
	"*:execute": "*:execute",
	/** Publish, activate, or restore all resources */
	"*:publish": "*:publish",
	/** View all resources */
	"*:read": "*:read",
	/** Change visibility/audience all resources */
	"*:share": "*:share",
	/** Create and modify all resources */
	"*:write": "*:write",
	/** Full access to agent-to-agent communication */
	"a2a:*": "a2a:*",
	/** Full access to agent builder */
	"agent-builder:*": "agent-builder:*",
	/** Full access to agent controller sessions */
	"agent-controller:*": "agent-controller:*",
	/** Full access to agents */
	"agents:*": "agents:*",
	/** Full access to auth */
	"auth:*": "auth:*",
	/** Full access to background tasks */
	"background-tasks:*": "background-tasks:*",
	/** Full access to channels */
	"channels:*": "channels:*",
	/** Full access to datasets */
	"datasets:*": "datasets:*",
	/** Full access to embedders */
	"embedders:*": "embedders:*",
	/** Full access to experiments */
	"experiments:*": "experiments:*",
	/** Full access to infrastructure */
	"infrastructure:*": "infrastructure:*",
	/** Full access to logs */
	"logs:*": "logs:*",
	/** Full access to MCP servers */
	"mcp:*": "mcp:*",
	/** Full access to memory and threads */
	"memory:*": "memory:*",
	/** Full access to traces and spans */
	"observability:*": "observability:*",
	/** Full access to processor-providers */
	"processor-providers:*": "processor-providers:*",
	/** Full access to processors */
	"processors:*": "processors:*",
	/** Full access to schedules */
	"schedules:*": "schedules:*",
	/** Full access to evaluation scores */
	"scores:*": "scores:*",
	/** Full access to stored agents */
	"stored-agents:*": "stored-agents:*",
	/** Full access to stored MCP clients */
	"stored-mcp-clients:*": "stored-mcp-clients:*",
	/** Full access to stored prompt blocks */
	"stored-prompt-blocks:*": "stored-prompt-blocks:*",
	/** Full access to stored scorers */
	"stored-scorers:*": "stored-scorers:*",
	/** Full access to stored skills */
	"stored-skills:*": "stored-skills:*",
	/** Full access to stored workflows */
	"stored-workflows:*": "stored-workflows:*",
	/** Full access to stored workspaces */
	"stored-workspaces:*": "stored-workspaces:*",
	/** Full access to system info */
	"system:*": "system:*",
	/** Full access to tool-providers */
	"tool-providers:*": "tool-providers:*",
	/** Full access to tools */
	"tools:*": "tools:*",
	/** Full access to vector stores */
	"vector:*": "vector:*",
	/** Full access to vectors */
	"vectors:*": "vectors:*",
	/** Full access to workflows */
	"workflows:*": "workflows:*",
	/** Full access to workspaces */
	"workspaces:*": "workspaces:*",
	/** View agent-to-agent communication */
	"a2a:read": "a2a:read",
	/** Create and modify agent-to-agent communication */
	"a2a:write": "a2a:write",
	/** Execute agent builder */
	"agent-builder:execute": "agent-builder:execute",
	/** View agent builder */
	"agent-builder:read": "agent-builder:read",
	/** Create and modify agent builder */
	"agent-builder:write": "agent-builder:write",
	/** Execute agent controller sessions */
	"agent-controller:execute": "agent-controller:execute",
	/** View agent controller sessions */
	"agent-controller:read": "agent-controller:read",
	/** Create agents */
	"agents:create": "agents:create",
	/** Delete agents */
	"agents:delete": "agents:delete",
	/** Execute agents */
	"agents:execute": "agents:execute",
	/** View agents */
	"agents:read": "agents:read",
	/** Create and modify agents */
	"agents:write": "agents:write",
	/** View auth */
	"auth:read": "auth:read",
	/** View background tasks */
	"background-tasks:read": "background-tasks:read",
	/** View channels */
	"channels:read": "channels:read",
	/** Create and modify channels */
	"channels:write": "channels:write",
	/** Delete datasets */
	"datasets:delete": "datasets:delete",
	/** Execute datasets */
	"datasets:execute": "datasets:execute",
	/** View datasets */
	"datasets:read": "datasets:read",
	/** Create and modify datasets */
	"datasets:write": "datasets:write",
	/** View embedders */
	"embedders:read": "embedders:read",
	/** View experiments */
	"experiments:read": "experiments:read",
	/** View infrastructure */
	"infrastructure:read": "infrastructure:read",
	/** View logs */
	"logs:read": "logs:read",
	/** Execute MCP servers */
	"mcp:execute": "mcp:execute",
	/** View MCP servers */
	"mcp:read": "mcp:read",
	/** Create and modify MCP servers */
	"mcp:write": "mcp:write",
	/** Delete memory and threads */
	"memory:delete": "memory:delete",
	/** Execute memory and threads */
	"memory:execute": "memory:execute",
	/** View memory and threads */
	"memory:read": "memory:read",
	/** Create and modify memory and threads */
	"memory:write": "memory:write",
	/** View traces and spans */
	"observability:read": "observability:read",
	/** Create and modify traces and spans */
	"observability:write": "observability:write",
	/** View processor-providers */
	"processor-providers:read": "processor-providers:read",
	/** Execute processors */
	"processors:execute": "processors:execute",
	/** View processors */
	"processors:read": "processors:read",
	/** Delete schedules */
	"schedules:delete": "schedules:delete",
	/** Execute schedules */
	"schedules:execute": "schedules:execute",
	/** View schedules */
	"schedules:read": "schedules:read",
	/** Create and modify schedules */
	"schedules:write": "schedules:write",
	/** View evaluation scores */
	"scores:read": "scores:read",
	/** Create and modify evaluation scores */
	"scores:write": "scores:write",
	/** Delete stored agents */
	"stored-agents:delete": "stored-agents:delete",
	/** Publish, activate, or restore stored agents */
	"stored-agents:publish": "stored-agents:publish",
	/** View stored agents */
	"stored-agents:read": "stored-agents:read",
	/** Create and modify stored agents */
	"stored-agents:write": "stored-agents:write",
	/** Delete stored MCP clients */
	"stored-mcp-clients:delete": "stored-mcp-clients:delete",
	/** Publish, activate, or restore stored MCP clients */
	"stored-mcp-clients:publish": "stored-mcp-clients:publish",
	/** View stored MCP clients */
	"stored-mcp-clients:read": "stored-mcp-clients:read",
	/** Create and modify stored MCP clients */
	"stored-mcp-clients:write": "stored-mcp-clients:write",
	/** Delete stored prompt blocks */
	"stored-prompt-blocks:delete": "stored-prompt-blocks:delete",
	/** Publish, activate, or restore stored prompt blocks */
	"stored-prompt-blocks:publish": "stored-prompt-blocks:publish",
	/** View stored prompt blocks */
	"stored-prompt-blocks:read": "stored-prompt-blocks:read",
	/** Create and modify stored prompt blocks */
	"stored-prompt-blocks:write": "stored-prompt-blocks:write",
	/** Delete stored scorers */
	"stored-scorers:delete": "stored-scorers:delete",
	/** Publish, activate, or restore stored scorers */
	"stored-scorers:publish": "stored-scorers:publish",
	/** View stored scorers */
	"stored-scorers:read": "stored-scorers:read",
	/** Create and modify stored scorers */
	"stored-scorers:write": "stored-scorers:write",
	/** Delete stored skills */
	"stored-skills:delete": "stored-skills:delete",
	/** Publish, activate, or restore stored skills */
	"stored-skills:publish": "stored-skills:publish",
	/** View stored skills */
	"stored-skills:read": "stored-skills:read",
	/** Create and modify stored skills */
	"stored-skills:write": "stored-skills:write",
	/** View stored workflows */
	"stored-workflows:read": "stored-workflows:read",
	/** Create and modify stored workflows */
	"stored-workflows:write": "stored-workflows:write",
	/** Delete stored workspaces */
	"stored-workspaces:delete": "stored-workspaces:delete",
	/** View stored workspaces */
	"stored-workspaces:read": "stored-workspaces:read",
	/** Create and modify stored workspaces */
	"stored-workspaces:write": "stored-workspaces:write",
	/** View system info */
	"system:read": "system:read",
	/** Delete tool-providers */
	"tool-providers:delete": "tool-providers:delete",
	/** View tool-providers */
	"tool-providers:read": "tool-providers:read",
	/** Create and modify tool-providers */
	"tool-providers:write": "tool-providers:write",
	/** Execute tools */
	"tools:execute": "tools:execute",
	/** View tools */
	"tools:read": "tools:read",
	/** Delete vector stores */
	"vector:delete": "vector:delete",
	/** Execute vector stores */
	"vector:execute": "vector:execute",
	/** View vector stores */
	"vector:read": "vector:read",
	/** Create and modify vector stores */
	"vector:write": "vector:write",
	/** View vectors */
	"vectors:read": "vectors:read",
	/** Delete workflows */
	"workflows:delete": "workflows:delete",
	/** Execute workflows */
	"workflows:execute": "workflows:execute",
	/** View workflows */
	"workflows:read": "workflows:read",
	/** Create and modify workflows */
	"workflows:write": "workflows:write",
	/** Delete workspaces */
	"workspaces:delete": "workspaces:delete",
	/** View workspaces */
	"workspaces:read": "workspaces:read",
	/** Create and modify workspaces */
	"workspaces:write": "workspaces:write",
	/** Full access to all stored resource families */
	"stored:*": "stored:*",
	/** View all stored resource families */
	"stored:read": "stored:read",
	/** Create and modify all stored resource families */
	"stored:write": "stored:write",
	/** Delete all stored resource families */
	"stored:delete": "stored:delete",
	/** Change visibility/audience stored agents */
	"stored-agents:share": "stored-agents:share",
	/** Change visibility/audience stored skills */
	"stored-skills:share": "stored-skills:share"
};
/**
* All valid resource:action permission combinations (excludes wildcards).
*/
const PERMISSIONS = [
	"a2a:read",
	"a2a:write",
	"agent-builder:execute",
	"agent-builder:read",
	"agent-builder:write",
	"agent-controller:execute",
	"agent-controller:read",
	"agents:create",
	"agents:delete",
	"agents:execute",
	"agents:read",
	"agents:write",
	"auth:read",
	"background-tasks:read",
	"channels:read",
	"channels:write",
	"datasets:delete",
	"datasets:execute",
	"datasets:read",
	"datasets:write",
	"embedders:read",
	"experiments:read",
	"infrastructure:read",
	"logs:read",
	"mcp:execute",
	"mcp:read",
	"mcp:write",
	"memory:delete",
	"memory:execute",
	"memory:read",
	"memory:write",
	"observability:read",
	"observability:write",
	"processor-providers:read",
	"processors:execute",
	"processors:read",
	"schedules:delete",
	"schedules:execute",
	"schedules:read",
	"schedules:write",
	"scores:read",
	"scores:write",
	"stored-agents:delete",
	"stored-agents:publish",
	"stored-agents:read",
	"stored-agents:write",
	"stored-mcp-clients:delete",
	"stored-mcp-clients:publish",
	"stored-mcp-clients:read",
	"stored-mcp-clients:write",
	"stored-prompt-blocks:delete",
	"stored-prompt-blocks:publish",
	"stored-prompt-blocks:read",
	"stored-prompt-blocks:write",
	"stored-scorers:delete",
	"stored-scorers:publish",
	"stored-scorers:read",
	"stored-scorers:write",
	"stored-skills:delete",
	"stored-skills:publish",
	"stored-skills:read",
	"stored-skills:write",
	"stored-workflows:read",
	"stored-workflows:write",
	"stored-workspaces:delete",
	"stored-workspaces:read",
	"stored-workspaces:write",
	"system:read",
	"tool-providers:delete",
	"tool-providers:read",
	"tool-providers:write",
	"tools:execute",
	"tools:read",
	"vector:delete",
	"vector:execute",
	"vector:read",
	"vector:write",
	"vectors:read",
	"workflows:delete",
	"workflows:execute",
	"workflows:read",
	"workflows:write",
	"workspaces:delete",
	"workspaces:read",
	"workspaces:write"
];
/**
* Type-safe constants for Mastra-owned FGA permissions.
*
* These values are generated from server routes and can be used wherever
* Mastra checks or maps FGA permissions.
*/
const MastraFGAPermissions = {
	/** View agent-to-agent communication */
	A2A_READ: "a2a:read",
	/** Create and modify agent-to-agent communication */
	A2A_WRITE: "a2a:write",
	/** Execute agent builder */
	AGENT_BUILDER_EXECUTE: "agent-builder:execute",
	/** View agent builder */
	AGENT_BUILDER_READ: "agent-builder:read",
	/** Create and modify agent builder */
	AGENT_BUILDER_WRITE: "agent-builder:write",
	/** Execute agent controller sessions */
	AGENT_CONTROLLER_EXECUTE: "agent-controller:execute",
	/** View agent controller sessions */
	AGENT_CONTROLLER_READ: "agent-controller:read",
	/** Create agents */
	AGENTS_CREATE: "agents:create",
	/** Delete agents */
	AGENTS_DELETE: "agents:delete",
	/** Execute agents */
	AGENTS_EXECUTE: "agents:execute",
	/** View agents */
	AGENTS_READ: "agents:read",
	/** Create and modify agents */
	AGENTS_WRITE: "agents:write",
	/** View auth */
	AUTH_READ: "auth:read",
	/** View background tasks */
	BACKGROUND_TASKS_READ: "background-tasks:read",
	/** View channels */
	CHANNELS_READ: "channels:read",
	/** Create and modify channels */
	CHANNELS_WRITE: "channels:write",
	/** Delete datasets */
	DATASETS_DELETE: "datasets:delete",
	/** Execute datasets */
	DATASETS_EXECUTE: "datasets:execute",
	/** View datasets */
	DATASETS_READ: "datasets:read",
	/** Create and modify datasets */
	DATASETS_WRITE: "datasets:write",
	/** View embedders */
	EMBEDDERS_READ: "embedders:read",
	/** View experiments */
	EXPERIMENTS_READ: "experiments:read",
	/** View infrastructure */
	INFRASTRUCTURE_READ: "infrastructure:read",
	/** View logs */
	LOGS_READ: "logs:read",
	/** Execute MCP servers */
	MCP_EXECUTE: "mcp:execute",
	/** View MCP servers */
	MCP_READ: "mcp:read",
	/** Create and modify MCP servers */
	MCP_WRITE: "mcp:write",
	/** Delete memory and threads */
	MEMORY_DELETE: "memory:delete",
	/** Execute memory and threads */
	MEMORY_EXECUTE: "memory:execute",
	/** View memory and threads */
	MEMORY_READ: "memory:read",
	/** Create and modify memory and threads */
	MEMORY_WRITE: "memory:write",
	/** View traces and spans */
	OBSERVABILITY_READ: "observability:read",
	/** Create and modify traces and spans */
	OBSERVABILITY_WRITE: "observability:write",
	/** View processor-providers */
	PROCESSOR_PROVIDERS_READ: "processor-providers:read",
	/** Execute processors */
	PROCESSORS_EXECUTE: "processors:execute",
	/** View processors */
	PROCESSORS_READ: "processors:read",
	/** Delete schedules */
	SCHEDULES_DELETE: "schedules:delete",
	/** Execute schedules */
	SCHEDULES_EXECUTE: "schedules:execute",
	/** View schedules */
	SCHEDULES_READ: "schedules:read",
	/** Create and modify schedules */
	SCHEDULES_WRITE: "schedules:write",
	/** View evaluation scores */
	SCORES_READ: "scores:read",
	/** Create and modify evaluation scores */
	SCORES_WRITE: "scores:write",
	/** Delete stored agents */
	STORED_AGENTS_DELETE: "stored-agents:delete",
	/** Publish, activate, or restore stored agents */
	STORED_AGENTS_PUBLISH: "stored-agents:publish",
	/** View stored agents */
	STORED_AGENTS_READ: "stored-agents:read",
	/** Create and modify stored agents */
	STORED_AGENTS_WRITE: "stored-agents:write",
	/** Delete stored MCP clients */
	STORED_MCP_CLIENTS_DELETE: "stored-mcp-clients:delete",
	/** Publish, activate, or restore stored MCP clients */
	STORED_MCP_CLIENTS_PUBLISH: "stored-mcp-clients:publish",
	/** View stored MCP clients */
	STORED_MCP_CLIENTS_READ: "stored-mcp-clients:read",
	/** Create and modify stored MCP clients */
	STORED_MCP_CLIENTS_WRITE: "stored-mcp-clients:write",
	/** Delete stored prompt blocks */
	STORED_PROMPT_BLOCKS_DELETE: "stored-prompt-blocks:delete",
	/** Publish, activate, or restore stored prompt blocks */
	STORED_PROMPT_BLOCKS_PUBLISH: "stored-prompt-blocks:publish",
	/** View stored prompt blocks */
	STORED_PROMPT_BLOCKS_READ: "stored-prompt-blocks:read",
	/** Create and modify stored prompt blocks */
	STORED_PROMPT_BLOCKS_WRITE: "stored-prompt-blocks:write",
	/** Delete stored scorers */
	STORED_SCORERS_DELETE: "stored-scorers:delete",
	/** Publish, activate, or restore stored scorers */
	STORED_SCORERS_PUBLISH: "stored-scorers:publish",
	/** View stored scorers */
	STORED_SCORERS_READ: "stored-scorers:read",
	/** Create and modify stored scorers */
	STORED_SCORERS_WRITE: "stored-scorers:write",
	/** Delete stored skills */
	STORED_SKILLS_DELETE: "stored-skills:delete",
	/** Publish, activate, or restore stored skills */
	STORED_SKILLS_PUBLISH: "stored-skills:publish",
	/** View stored skills */
	STORED_SKILLS_READ: "stored-skills:read",
	/** Create and modify stored skills */
	STORED_SKILLS_WRITE: "stored-skills:write",
	/** View stored workflows */
	STORED_WORKFLOWS_READ: "stored-workflows:read",
	/** Create and modify stored workflows */
	STORED_WORKFLOWS_WRITE: "stored-workflows:write",
	/** Delete stored workspaces */
	STORED_WORKSPACES_DELETE: "stored-workspaces:delete",
	/** View stored workspaces */
	STORED_WORKSPACES_READ: "stored-workspaces:read",
	/** Create and modify stored workspaces */
	STORED_WORKSPACES_WRITE: "stored-workspaces:write",
	/** View system info */
	SYSTEM_READ: "system:read",
	/** Delete tool-providers */
	TOOL_PROVIDERS_DELETE: "tool-providers:delete",
	/** View tool-providers */
	TOOL_PROVIDERS_READ: "tool-providers:read",
	/** Create and modify tool-providers */
	TOOL_PROVIDERS_WRITE: "tool-providers:write",
	/** Execute tools */
	TOOLS_EXECUTE: "tools:execute",
	/** View tools */
	TOOLS_READ: "tools:read",
	/** Delete vector stores */
	VECTOR_DELETE: "vector:delete",
	/** Execute vector stores */
	VECTOR_EXECUTE: "vector:execute",
	/** View vector stores */
	VECTOR_READ: "vector:read",
	/** Create and modify vector stores */
	VECTOR_WRITE: "vector:write",
	/** View vectors */
	VECTORS_READ: "vectors:read",
	/** Delete workflows */
	WORKFLOWS_DELETE: "workflows:delete",
	/** Execute workflows */
	WORKFLOWS_EXECUTE: "workflows:execute",
	/** View workflows */
	WORKFLOWS_READ: "workflows:read",
	/** Create and modify workflows */
	WORKFLOWS_WRITE: "workflows:write",
	/** Delete workspaces */
	WORKSPACES_DELETE: "workspaces:delete",
	/** View workspaces */
	WORKSPACES_READ: "workspaces:read",
	/** Create and modify workspaces */
	WORKSPACES_WRITE: "workspaces:write"
};
/**
* Validates that a string is a valid permission pattern.
* Useful for runtime validation of permission strings.
*/
function isValidPermissionPattern(pattern) {
	return pattern in PERMISSION_PATTERNS;
}
/**
* Validates that all permissions in an array are valid patterns.
*/
function validatePermissions(permissions) {
	return permissions.every(isValidPermissionPattern);
}
//#endregion
//#region src/ee/fga-check.ts
/**
* FGA enforcement utility for checking fine-grained authorization.
*
* @license Mastra Enterprise License - see ee/LICENSE
*/
function mergeFGAContext({ context, requestContext, metadata }) {
	const mergedContext = { ...context };
	if (requestContext) mergedContext.requestContext = requestContext;
	if (metadata || context?.metadata) mergedContext.metadata = {
		...context?.metadata ?? {},
		...metadata ?? {}
	};
	return Object.keys(mergedContext).length > 0 ? mergedContext : void 0;
}
function isActorSignal(actor) {
	if (actor === true) return true;
	if (typeof actor !== "object" || actor === null) return false;
	const candidate = actor;
	return candidate.actorKind === "system" && (candidate.sourceWorkflow === void 0 || typeof candidate.sourceWorkflow === "string");
}
function getAgentFGAResourceId(agentId) {
	return agentId;
}
function getWorkflowFGAResourceId(workflowId) {
	return workflowId;
}
function getStandaloneToolFGAResourceId(toolName) {
	return toolName;
}
function getAgentToolFGAResourceId(agentId, toolName) {
	return `${agentId}:${toolName}`;
}
function getMCPToolFGAResourceId(serverName, toolName) {
	return JSON.stringify([serverName, toolName]);
}
/**
* Check fine-grained authorization for a resource.
*
* No-op if no FGA provider is configured (backward compatibility).
* Delegates to fgaProvider.require() which throws FGADeniedError if denied.
*/
async function checkFGA(options) {
	await requireFGA(options);
}
/**
* Require fine-grained authorization for a resource.
*
* No-op if no FGA provider is configured. When FGA is configured, a missing
* user fails closed.
*/
async function requireFGA(options) {
	const { fgaProvider, user, resource, permission, context, requestContext, metadata, actor } = options;
	if (!fgaProvider) return;
	const fgaContext = mergeFGAContext({
		context,
		requestContext,
		metadata
	});
	const license = getSafeLicenseSummary();
	if (isActorSignal(actor)) {
		const tenantOrganizationId = fgaContext?.requestContext?.get("organizationId");
		if (typeof tenantOrganizationId !== "string" || tenantOrganizationId.length === 0) throw new FGADeniedError(user, resource, permission, "trusted actor requires organizationId / tenant scope");
		const sourceWorkflow = (actor === true ? void 0 : actor.sourceWorkflow) ?? (typeof fgaContext?.metadata?.["sourceWorkflow"] === "string" ? fgaContext.metadata["sourceWorkflow"] : void 0);
		const providerEnforced = typeof fgaProvider.requireActor === "function";
		if (providerEnforced) await fgaProvider.requireActor(actor, {
			resource,
			permission,
			...fgaContext ? { context: fgaContext } : {}
		});
		try {
			captureEEEvent("ee_feature_used", license.anonymousId || getEETelemetryFallbackDistinctId(), {
				feature: "fga",
				actor_kind: "system",
				actor_authorized_by: providerEnforced ? "provider" : "bypass",
				resource_type: resource.type,
				resource_id: resource.id,
				permission,
				user_id: null,
				organization_membership_id: null,
				source_workflow: sourceWorkflow,
				license_valid: license.valid,
				license_hash: license.licenseHash,
				is_dev_environment: license.isDevEnvironment
			});
		} catch {}
		return;
	}
	if (!user) throw new FGADeniedError(user, resource, permission, "authenticated user is required");
	await fgaProvider.require(user, fgaContext ? {
		resource,
		permission,
		context: fgaContext
	} : {
		resource,
		permission
	});
	try {
		captureEEEvent("ee_feature_used", user?.id || license.anonymousId || getEETelemetryFallbackDistinctId(), {
			feature: "fga",
			actor_kind: "user",
			resource_type: resource.type,
			resource_id: resource.id,
			permission,
			user_id: user?.id ?? null,
			organization_membership_id: user?.organizationMembershipId ?? null,
			license_valid: license.valid,
			license_hash: license.licenseHash,
			is_dev_environment: license.isDevEnvironment
		});
	} catch {}
}
/**
* Error thrown when an FGA authorization check is denied.
*/
var FGADeniedError = class extends Error {
	user;
	resource;
	permission;
	status;
	constructor(user, resource, permission, reason) {
		const userId = user?.id || user?.workosId || "unknown";
		const permissionLabel = Array.isArray(permission) ? `any of [${permission.join(", ")}]` : permission;
		super(reason ? `FGA authorization denied: ${reason}` : `FGA authorization denied: user ${userId} cannot ${permissionLabel} on ${resource.type}:${resource.id}`);
		this.name = "FGADeniedError";
		this.user = user;
		this.resource = resource;
		this.permission = permission;
		this.status = 403;
	}
};
//#endregion
//#region src/ee/defaults/roles.ts
/**
* Default role definitions for Studio.
*
* These roles provide a sensible starting point for most applications:
* - **owner**: Full access to everything
* - **admin**: Manage agents, workflows, and users
* - **member**: Execute agents and workflows, read-only settings
* - **viewer**: Read-only access
*
* Permission patterns:
* - `*` - Full access to everything
* - `resource:*` - All actions on a specific resource
* - `*:action` - An action across all resources (e.g., `*:read` for read-only)
*/
const DEFAULT_ROLES = [
	{
		id: "owner",
		name: "Owner",
		description: "Full access to all features and settings",
		permissions: ["*"]
	},
	{
		id: "admin",
		name: "Admin",
		description: "Manage agents, workflows, and team members",
		permissions: [
			"*:read",
			"*:write",
			"*:execute",
			"*:publish",
			"*:share"
		]
	},
	{
		id: "member",
		name: "Member",
		description: "Execute agents and workflows",
		permissions: ["*:read", "*:execute"]
	},
	{
		id: "viewer",
		name: "Viewer",
		description: "Read-only access",
		permissions: ["*:read"]
	}
];
/**
* Get role by ID from default roles.
*
* @param roleId - Role ID to find
* @returns Role definition or undefined
*/
function getDefaultRole(roleId) {
	return DEFAULT_ROLES.find((role) => role.id === roleId);
}
/**
* Resolve all permissions for a set of role IDs.
*
* Handles role inheritance and deduplication.
*
* @param roleIds - Role IDs to resolve
* @param roles - Role definitions (defaults to DEFAULT_ROLES)
* @returns Array of resolved permissions
*/
function resolvePermissions(roleIds, roles = DEFAULT_ROLES) {
	const permissions = /* @__PURE__ */ new Set();
	const visited = /* @__PURE__ */ new Set();
	function resolveRole(roleId) {
		if (visited.has(roleId)) return;
		visited.add(roleId);
		const role = roles.find((r) => r.id === roleId);
		if (!role) return;
		for (const permission of role.permissions) permissions.add(permission);
		if (role.inherits) for (const inheritedRoleId of role.inherits) resolveRole(inheritedRoleId);
	}
	for (const roleId of roleIds) resolveRole(roleId);
	return Array.from(permissions);
}
/**
* Compound resource keys that expand to a set of per-family resources.
* A granted `stored:<action>` is treated as matching any `stored-<family>:<action>`
* (and `stored:*` matches any `stored-<family>:*`).
*/
const RESOURCE_EXPANSIONS = { stored: [
	"stored-agents",
	"stored-mcp-clients",
	"stored-prompt-blocks",
	"stored-scorers",
	"stored-skills",
	"stored-workspaces"
] };
/**
* Check if a permission matches (including wildcard support).
*
* Permission format: `{resource}:{action}[:{resource-id}]`
*
* Examples:
* - `*` matches everything
* - `agents:*` matches `agents:read`, `agents:read:my-agent`
* - `*:read` matches `agents:read`, `workflows:read` (action across all resources)
* - `agents:read` matches `agents:read`, `agents:read:my-agent`
* - `agents:read:my-agent` matches only `agents:read:my-agent`
* - `agents:*:my-agent` matches `agents:read:my-agent`, `agents:write:my-agent`
*
* @param userPermission - Permission the user has
* @param requiredPermission - Permission being checked
* @returns True if permission matches
*/
function matchesPermission(userPermission, requiredPermission) {
	if (userPermission === "*") return true;
	const grantedParts = userPermission.split(":");
	const requiredParts = requiredPermission.split(":");
	const expandedFamilies = RESOURCE_EXPANSIONS[grantedParts[0] ?? ""];
	if (expandedFamilies && expandedFamilies.includes(requiredParts[0] ?? "")) return matchesPermission([requiredParts[0], ...grantedParts.slice(1)].join(":"), requiredPermission);
	if (grantedParts.length < 2 || requiredParts.length < 2) return userPermission === requiredPermission;
	const [grantedResource, grantedAction, grantedId] = grantedParts;
	const [requiredResource, requiredAction, requiredId] = requiredParts;
	if (grantedResource === "*") {
		if (grantedAction === "*") {
			if (grantedId === void 0) return true;
			return grantedId === requiredId;
		}
		if (grantedAction !== requiredAction) return false;
		if (grantedId === void 0) return true;
		return grantedId === requiredId;
	}
	if (grantedResource !== requiredResource) return false;
	if (grantedAction === "*") {
		if (grantedId === void 0) return true;
		return grantedId === requiredId;
	}
	if (grantedAction !== requiredAction) return false;
	if (grantedId === void 0) return true;
	return grantedId === requiredId;
}
/**
* Check if a user has a specific permission.
*
* @param userPermissions - Permissions the user has
* @param requiredPermission - Permission being checked
* @returns True if user has the permission
*/
function hasPermission(userPermissions, requiredPermission) {
	return userPermissions.some((p) => matchesPermission(p, requiredPermission));
}
/**
* Resolve permissions from user roles using a role mapping.
*
* This function translates provider-defined roles (from WorkOS, Okta, etc.)
* to Mastra permissions using a configurable mapping.
*
* @example
* ```typescript
* const roleMapping = {
*   "Engineering": ["agents:*", "workflows:*"],
*   "Product": ["agents:read"],
*   "_default": [],
* };
*
* // User has "Engineering" and "QA" roles
* const permissions = resolvePermissionsFromMapping(
*   ["Engineering", "QA"],
*   roleMapping
* );
* // Result: ["agents:*", "workflows:*"] (QA is unmapped, gets _default)
* ```
*
* @param roles - User's roles from the identity provider
* @param mapping - Role to permission mapping
* @returns Array of resolved permissions
*/
function resolvePermissionsFromMapping(roles, mapping) {
	const permissions = /* @__PURE__ */ new Set();
	const defaultPerms = mapping["_default"] ?? [];
	for (const role of roles) {
		const rolePerms = mapping[role];
		if (rolePerms) for (const perm of rolePerms) permissions.add(perm);
		else for (const perm of defaultPerms) permissions.add(perm);
	}
	return Array.from(permissions);
}
//#endregion
//#region src/ee/defaults/rbac/static.ts
/**
* Static RBAC provider.
*
* Supports two modes:
* 1. **Role definitions**: Use Mastra's native role system with structured roles
* 2. **Role mapping**: Directly map provider roles to permissions
*
* @example Using role definitions (Mastra's native system)
* ```typescript
* const rbac = new StaticRBACProvider({
*   roles: DEFAULT_ROLES,
*   getUserRoles: (user) => [user.role],
* });
* ```
*
* @example Using role mapping (for external providers)
* ```typescript
* const rbac = new StaticRBACProvider({
*   roleMapping: {
*     "Engineering": ["agents:*", "workflows:*"],
*     "Product": ["agents:read", "workflows:read"],
*     "_default": [],
*   },
*   getUserRoles: (user) => user.providerRoles,
* });
* ```
*
* @example Async role lookup
* ```typescript
* const rbac = new StaticRBACProvider({
*   roles: DEFAULT_ROLES,
*   getUserRoles: async (user) => {
*     return db.getUserRoles(user.id);
*   },
* });
* ```
*/
var StaticRBACProvider = class {
	roles;
	_roleMapping;
	getUserRolesFn;
	permissionCache = /* @__PURE__ */ new Map();
	/** Expose roleMapping for middleware access */
	get roleMapping() {
		return this._roleMapping;
	}
	constructor(options) {
		if ("roles" in options && options.roles) this.roles = options.roles;
		if ("roleMapping" in options && options.roleMapping) this._roleMapping = options.roleMapping;
		this.getUserRolesFn = options.getUserRoles;
	}
	async getRoles(user) {
		return await this.getUserRolesFn(user);
	}
	async hasRole(user, role) {
		return (await this.getRoles(user)).includes(role);
	}
	async getPermissions(user) {
		const roleIds = await this.getRoles(user);
		const cacheKey = roleIds.sort().join(",");
		const cached = this.permissionCache.get(cacheKey);
		if (cached) return cached;
		let permissions;
		if (this._roleMapping) permissions = resolvePermissionsFromMapping(roleIds, this._roleMapping);
		else if (this.roles) permissions = resolvePermissions(roleIds, this.roles);
		else permissions = [];
		this.permissionCache.set(cacheKey, permissions);
		return permissions;
	}
	async hasPermission(user, permission) {
		return (await this.getPermissions(user)).some((p) => matchesPermission(p, permission));
	}
	async hasAllPermissions(user, permissions) {
		const userPermissions = await this.getPermissions(user);
		return permissions.every((required) => userPermissions.some((p) => matchesPermission(p, required)));
	}
	async hasAnyPermission(user, permissions) {
		const userPermissions = await this.getPermissions(user);
		return permissions.some((required) => userPermissions.some((p) => matchesPermission(p, required)));
	}
	/**
	* Clear the permission cache.
	*/
	clearCache() {
		this.permissionCache.clear();
	}
	/**
	* Get all role definitions.
	* Only available when using role definitions mode (not role mapping).
	*/
	getRoleDefinitions() {
		return this.roles ?? [];
	}
	/**
	* Get a specific role definition.
	* Only available when using role definitions mode (not role mapping).
	*/
	getRoleDefinition(roleId) {
		return this.roles?.find((r) => r.id === roleId);
	}
	/**
	* Get all available roles in the system.
	*/
	async getAvailableRoles() {
		if (this.roles) return this.roles.map((r) => ({
			id: r.id,
			name: r.name
		}));
		if (this._roleMapping) return Object.keys(this._roleMapping).filter((k) => k !== "_default").map((k) => ({
			id: k,
			name: k
		}));
		return [];
	}
	/**
	* Get the resolved permissions for a specific role.
	*/
	async getPermissionsForRole(roleId) {
		if (this._roleMapping) return resolvePermissionsFromMapping([roleId], this._roleMapping);
		if (this.roles) return resolvePermissions([roleId], this.roles);
		return [];
	}
};
//#endregion
//#region src/ee/index.ts
/**
* @mastra/core/auth/ee
*
* Enterprise authentication capabilities for Mastra.
* This code is licensed under the Mastra Enterprise License - see ee/LICENSE.
*
* @license Mastra Enterprise License - see ee/LICENSE
* @packageDocumentation
*/
//#endregion
export { validatePermissions as S, MastraFGAPermissions as _, matchesPermission as a, RESOURCES as b, FGADeniedError as c, getAgentToolFGAResourceId as d, getMCPToolFGAResourceId as f, ACTIONS as g, requireFGA as h, hasPermission as i, checkFGA as l, getWorkflowFGAResourceId as m, DEFAULT_ROLES as n, resolvePermissions as o, getStandaloneToolFGAResourceId as p, getDefaultRole as r, resolvePermissionsFromMapping as s, StaticRBACProvider as t, getAgentFGAResourceId as u, PERMISSIONS as v, isValidPermissionPattern as x, PERMISSION_PATTERNS as y };

//# sourceMappingURL=ee-DXvSoTl7.js.map